const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8080";

export async function register(phoneNumber, name) {
    const url = new URL(`/api/auth/register`, BASE_URL);

    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber, name }),
    });

    if (!res.ok) {
        const error = await res.json().catch(() => ({ message: "Registration failed" }));
        throw new Error(error.message || `HTTP ${res.status}`);
    }

    return await res.json();
}

export async function sendOtp(phoneNumber) {
    const url = new URL(`/api/auth/send-otp`, BASE_URL);

    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber }),
    });

    if (!res.ok) {
        const error = await res.json().catch(() => ({ message: "Failed to send OTP" }));
        throw new Error(error.message || `HTTP ${res.status}`);
    }

    return await res.json();
}

export async function verifyOtp(phoneNumber, code) {
    const url = new URL(`/api/auth/verify-otp`, BASE_URL);

    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ phoneNumber, code }),
    });

    if (!res.ok) {
        const error = await res.json().catch(() => ({ message: "Verification failed" }));
        throw new Error(error.message || `HTTP ${res.status}`);
    }

    return await res.json();
}

export async function refreshAccessToken() {
    const url = new URL(`/api/auth/refresh`, BASE_URL);

    const res = await fetch(url, {
        method: "POST",
        credentials: "include",
    });

    if (!res.ok) {
        const error = await res.json().catch(() => ({ message: "Token refresh failed" }));
        throw new Error(error.message || `HTTP ${res.status}`);
    }

    return await res.json();
}
